
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";
export default function InfoCard({
  accountData,
  className = "",
  onDrawdownDataChange = () => {},
}) {
  const navigate = useNavigate();
  const { accountId: accountCode } = useParams();
  const [drawdownData, setDrawdownData] = useState(null);
  const fetchDrawdownData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}trading/accounts/${accountCode}/drawdown-limits/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try to refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}auth/trader/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → log out and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            navigate("/signin");
            return; // ⬅️ IMPORTANT: stop here
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new access token
          response = await fetch(
            `${API_BASE_URL}trading/accounts/${accountCode}/drawdown-limits/`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("access")}`,
              },
            },
          );
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // handle final response (original or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setDrawdownData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    setDrawdownData(null);
    fetchDrawdownData();
  }, [accountCode]);
  useEffect(() => {
    onDrawdownDataChange(drawdownData);
  }, [drawdownData, onDrawdownDataChange]);
  return (
    <div
      className={`w-full flex lg:flex-col text-xs sm:text-sm text-zi-text-light dark:text-zi-text-dark ${className}`}
    >
      <div className="w-full flex flex-col gap-3 pl-3 lg:pl-0 lg:pb-3 overflow-x-hidden">
        <div className="w-full flex justify-between items-center gap-2 overflow-x-auto">
          <span className="opacity-50 whitespace-nowrap">بالانس</span>
          <span className="font-medium">
            $
            {accountData
              ? Number(
                  Number(accountData.account.balance).toFixed(2),
                ).toLocaleString()
              : ""}
          </span>
        </div>
        <div className="w-full flex justify-between items-center gap-2 overflow-x-auto">
          <span className="opacity-50 whitespace-nowrap">اکوئیتی</span>
          <span className="font-medium">
            $
            {accountData
              ? Number(
                  Number(accountData.account.equity).toFixed(2),
                ).toLocaleString()
              : ""}
          </span>
        </div>
        <div className="w-full flex justify-between items-center gap-2 overflow-x-auto">
          <span className="opacity-50 whitespace-nowrap">مارجین</span>
          <span className="font-medium">
            $
            {accountData
              ? Number(
                  Number(accountData.account.margin_used).toFixed(2),
                ).toLocaleString()
              : ""}
          </span>
        </div>
        <div className="w-full flex justify-between items-center gap-2 overflow-x-auto">
          <span className="opacity-50 whitespace-nowrap">مارجین آزاد</span>
          <span className="font-medium">
            $
            {accountData
              ? Number(
                  Number(accountData.account.free_margin).toFixed(2),
                ).toLocaleString()
              : ""}
          </span>
        </div>
      </div>

      <div className="w-px h-auto self-stretch bg-zi-border-dark/50 dark:hidden lg:w-full lg:h-px" />
      <div className="card-divider hidden w-px h-auto self-stretch bg-[linear-gradient(180deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)] dark:block lg:w-full lg:h-px lg:bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />

      <div className="w-full flex flex-col gap-3 pr-3 lg:pr-0 lg:pt-3 overflow-x-hidden">
        <div className="w-full flex justify-between items-center gap-2 overflow-x-auto">
          <span className="opacity-50 whitespace-nowrap">سود غیر قطعی</span>
          <span
            className={`font-medium [direction:ltr] ${accountData && Number(accountData.account.unrealized_pnl) < 0 ? "text-zi-red-dark" : accountData && Number(accountData.account.unrealized_pnl) > 0 ? "text-zi-green-dark" : ""}`}
          >
            {accountData
              ? Number(accountData.account.unrealized_pnl) >= 0
                ? `$${Number(
                    Number(accountData.account.unrealized_pnl).toFixed(2),
                  ).toLocaleString()}`
                : `-$${Number(
                    Number(-1 * accountData.account.unrealized_pnl).toFixed(2),
                  ).toLocaleString()}`
              : ""}
          </span>
        </div>
        <div className="w-full flex justify-between items-center gap-2 overflow-x-auto">
          <span className="opacity-50 whitespace-nowrap">حد زیان مجاز</span>
          <span className="font-medium">
            $
            {drawdownData
              ? Number(
                  Number(drawdownData?.max_drawdown_limit).toFixed(2),
                ).toLocaleString()
              : ""}
          </span>
        </div>
        <div className="w-full flex justify-between items-center gap-2 overflow-x-auto">
          <span className="opacity-50 whitespace-nowrap">حد زیان روزانه</span>
          <span className="font-medium">
            $
            {drawdownData
              ? Number(
                  Number(drawdownData?.daily_drawdown_limit).toFixed(2),
                ).toLocaleString()
              : ""}
          </span>
        </div>
        <div className="w-full flex justify-between items-center gap-2 overflow-x-auto">
          <span className="opacity-50 whitespace-nowrap">زیان مجاز هر معامله</span>
          <span className="font-medium">
            $
            {drawdownData
              ? Number(
                  Number(
                    -1 * Number(drawdownData?.trade_drawdown_limit),
                  ).toFixed(2),
                ).toLocaleString()
              : ""}
          </span>
        </div>
      </div>
    </div>
  );
}
